const jsxRuntime = require('react/jsx-runtime');

module.exports = {
  ...jsxRuntime,
  // Fallback for bundles that emit jsxDEV while runtime exposes only jsx/jsxs.
  jsxDEV: jsxRuntime.jsx,
};
